import { cn } from "@/lib/utils";
import { statisticsSidebarSurfaceCardClassName } from "../Statistics/components/statisticsShadcnCardShell";

/** Strategies list main card — sidebar surface in dark mode (matches Simulator / Reports). */
export const strategiesMainCardClassName = cn(
  "flex w-full min-w-0 flex-col gap-4 rounded-[6px] border border-border bg-card p-4 text-card-foreground shadow-none",
  statisticsSidebarSurfaceCardClassName,
);
